import React, { useState } from "react";
import axios from "axios";
import config from "../config";
import FeatureCheckbox from "../components/FeatureCheckbox";

const AddPrayerGuides = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [addToFeature, setAddToFeature] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!title.trim()) validationErrors.title = "Prayer Guide Title is required";
    if (!message.trim()) validationErrors.message = "Prayer Guide Message is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const postData = {
        catId: 3,
        prayerType: "prayerguide",
        title: title,
        description: message,
        reference: null,
        numberOfTask: null,
        file: null,
        isFeatured: addToFeature,
      };

      const response = await axios.post(
        `${config.BASE_URL}/apis/create-post-admin`,
        postData
      );

      if (response.data.success) {
        alert("Prayer Guide created successfully!");
        setTitle("");
        setMessage("");
        setAddToFeature(false);
      } else {
        alert("Failed to create Prayer Guide: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while creating Prayer Guide.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white shadow-md rounded-md">
      <div className="bg-orange-500 text-white px-4 py-3 rounded-t-md">
        <h2 className="font-semibold">Add New Prayer Guide</h2>
      </div>

      <div className="p-6">
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-4">
            <label htmlFor="title" className="block text-gray-700 font-medium mb-1">
              Prayer Guide Title
            </label>
            <input
              id="title"
              type="text"
              placeholder="Enter Prayer Guide Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.title ? "border-red-500" : "border-gray-300"
              }`}
              required
              disabled={loading}
            />
            {errors.title && (
              <p className="text-red-500 text-sm mt-1">{errors.title}</p>
            )}
          </div>

          <div className="mb-6">
            <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
              Prayer Guide Message
            </label>
            <textarea
              id="message"
              placeholder="Enter Prayer Guide Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 resize-none ${
                errors.message ? "border-red-500" : "border-gray-300"
              }`}
              rows={4}
              required
              disabled={loading}
            />
            {errors.message && (
              <p className="text-red-500 text-sm mt-1">{errors.message}</p>
            )}
          </div>

          <div className="flex flex-wrap items-center justify-between gap-4">
            <FeatureCheckbox checked={addToFeature} onChange={setAddToFeature} disabled={loading} />
            <button
              type="submit"
              disabled={loading}
              className={`bg-orange-500 text-white font-semibold px-6 py-2 rounded hover:bg-orange-600 transition ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "Submitting..." : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPrayerGuides;
